import React from 'react'
import { memo } from '~/ui/component'
import { PopupMenu, PopupMenuItem, Toolbar, VBox } from '~/ui/components'
import { useResourceTranslation } from '~/ui/resources'
import { useHomeScreenWidgets } from './HomeScreenWidgetContext'
import { HomeScreenWidget } from '~/models'

const HomeScreenWidgetsToolbar = memo('HomeScreenWidgetsToolbar', () => {

  const {
    addWidget,
    editingItems,
    startEditingItems,
    stopEditingItems,
  } = useHomeScreenWidgets()

  const {t} = useResourceTranslation('projects')

  const popupMenuItems = React.useMemo(() => {
    const items: PopupMenuItem[] = HomeScreenWidget.available
      .map(type => ({
        caption:  t(`home-screen.widgets.types.${type}`),
        icon:     HomeScreenWidget.iconForType(type),
        onSelect: () => addWidget(type),
    }))

    return items
  }, [t, addWidget])

  //------
  // Rendering

  function render() {
    return(
      <Toolbar style='panel'>
        <VBox>
          {!editingItems && renderAddButton()}
        </VBox>
        <VBox>
          {editingItems ? renderDoneButton() : renderEditButton()}
        </VBox>
      </Toolbar>
    )
  }

  function renderAddButton() {
    return(
      <PopupMenu items={popupMenuItems}>
        {toggle => (
          <Toolbar.Button
            icon='plus'
            caption={t('buttons:add')}
            onTap={toggle}
          />
        )}
      </PopupMenu>
    )
  }

  function renderEditButton() {
    return(
      <Toolbar.Button
        icon='pencil'
        caption={t('buttons:edit')}
        onTap={startEditingItems}
      />
    )
  }

  function renderDoneButton() {
    return(
      <Toolbar.Button
        icon='check'
        caption={t('buttons:done')}
        onTap={stopEditingItems}
      />
    )
  }

  return render()

})

export default HomeScreenWidgetsToolbar